export default __webpack_public_path__ + "static/The-US-remote-northernoutpost-89d59e8d290c162d30df0bf4cf2bca02.jpg";